import { html } from "lit-element";

export const styles = html`
<style>
    :host {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: white;
        z-index: 9998;
    }

    .secondary-toolbar > * {
        height: calc(100vh - 60px);
        position: absolute;
        right: 0;
        overflow-y: auto;
        background-color: var(--secondary-color);
        color: var(--primary-color-variant1);
        fill: var(--primary-color-variant1);
        stroke: var(--primary-color-variant1);
    }

    .container {
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: row;
    }

    .canvas-wrapper {
        display: flex;
        justify-content: space-around;
        background-color: gainsboro;
        width: 100%;
        height: 100%;
        outline: none;
    }

    .canvas-wrapper div.canvas-container {
        max-width: 100%;
        max-height: 100%;
        overflow: hidden;
        border: 1px solid black;
    }

    canvas {
        display: block;
    }
</style>
`;
